// import '../assets/css/bootstrap.css'
// import '../assets/font-awesome/css/font-awesome.css'
// import '../assets/css/plugins/select2/select2.min.css'
// import '../assets/css/animate.css'
// import '../assets/css/style.css'
// import '../assets/css/custom.css'
// import 'vue-select/dist/vue-select.css'
import Vue from 'vue'

Vue.config.debug = process.env.NODE_ENV !== 'production'

// import jQuery from 'jquery'

// window.$ = window.jQuery = jQuery

// require('bootstrap')

// require('metismenu')